module.exports = __webpack_public_path__ + "static/media/melissa6.d053e653.jpg";